import { useEffect, useState, useContext, useRef } from 'react'
import { Routes, Route, Outlet, Link } from 'react-router-dom'
import { Button } from '@mui/material'
import one from '../../assets/one.png'
import two from '../../assets/two.png'
import three from '../../assets/three.jpg'

import apple from '../../assets/apple.svg'
import google from '../../assets/google.svg'
import { Hero } from './cards/hero'

export const Home = ({ user }) => {
  return (
    <>
      <section className='w-full py-12 md:py-24 lg:py-32 flex justify-center'>
        <div className='container space-y-12 px-10 md:px-168'>
          <Hero />
        </div>
      </section>
      <section className='w-full py-12 md:py-24 lg:py-32 flex justify-center'>
        <div className='container space-y-12 px-4 md:px-6'>
          <div className='flex flex-col items-center justify-center space-y-4 text-center'>
            <div className='space-y-2'>
              <h1 className='text-3xl font-bold tracking-tighter sm:text-5xl'>
                BUILD Community
              </h1>
              <p className='max-w-[900px] text-gray-500 md:text-xl/relaxed lg:text-base/relaxed xl:text-xl/relaxed dark:text-gray-500'>
                Only available to people with a HarvardKey. Create groups
                visible to the whole university or create groups just for friends.
                Post and publicize events.
              </p>
            </div>
          </div>
          <div className='grid gap-4 md:gap-8 lg:gap-12'>
            <img
              alt='Screenshot'
              className='mx-auto rounded-xl overflow-hidden aspect-video object-cover object-center'
              height='480'
              src={one}
              width='1064'
            />
          </div>
        </div>
      </section>
      <section className='w-full py-12 md:py-24 lg:py-32 flex justify-center'>
        <div className='container space-y-12 px-4 md:px-6'>
          <div className='flex flex-col items-center justify-center space-y-4 text-center'>
            <div className='space-y-2'>
              <h1 className='text-3xl font-bold tracking-tighter sm:text-5xl'>
                EXPLORE Interests
              </h1>
              <p className='max-w-[900px] text-gray-500 md:text-xl/relaxed lg:text-base/relaxed xl:text-xl/relaxed dark:text-gray-500'>
                Everything happening in one place. No more toggling!
              </p>
            </div>
          </div>
          <div className='grid gap-4 md:gap-8 lg:gap-12'>
            <img
              alt='Screenshot'
              className='mx-auto rounded-xl overflow-hidden object-cover object-center'
              height='480'
              src={two}
              width='1064'
            />
          </div>
        </div>
      </section>
      <section className='w-full py-12 md:py-24 lg:py-32 flex justify-center'>
        <div className='container space-y-12 px-4 md:px-6'>
          <div className='flex flex-col items-center justify-center space-y-4 text-center'>
            <div className='space-y-2'>
              <h1 className='text-3xl font-bold tracking-tighter sm:text-5xl'>
                CONNECT to new and existing friends
              </h1>
              <p className='max-w-[900px] text-gray-500 md:text-xl/relaxed lg:text-base/relaxed xl:text-xl/relaxed dark:text-gray-500'>
                Find others with similar interests. Transform free time into
                social time. Increase number, quality, and diversity of
                relationships.
              </p>
            </div>
          </div>
          <div className='grid gap-4 md:gap-8 lg:gap-12'>
            <img
              alt='Screenshot'
              className='mx-auto rounded-xl overflow-hidden aspect-video object-cover object-center'
              height='480'
              src={three}
              width='1064'
            />
          </div>
          <div>
            <div className='flex flex-col gap-6 min-[400px]:flex-row flex-start bg-red px-6'>
              <Link to='https://app.joinu.org'>
                <Button variant='contained' size='large'>
                  Login
                </Button>
              </Link>
            </div>
            <div className='flex flex-col gap-6 min-[400px]:flex-row flex-start bg-red p-6'>
              <Link to='https://apps.apple.com/us/app/joinu-harvard/id6459098232'>
                <img
                  alt='apple store link'
                  className='mx-auto rounded-xl overflow-hidden aspect-video object-cover object-center'
                  width='140'
                  src={apple}
                />
              </Link>
              <Link to='https://play.google.com/store/apps/details?id=com.elijamunn.joinuharvard&hl=en_US'>
                <img
                  alt='apple store link'
                  className='mx-auto rounded-xl overflow-hidden aspect-video object-cover object-center'
                  width='140'
                  src={google}
                />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
